import { DevicePermission } from 'console/device/device_ts';
import { StateTabContents } from 'console/tabs/legacy/state/components/state-tab';
import { LegacyDevice } from 'console/device/device';
export const LegacyStateTabDefinition = {
    key: 'legacy-ui-state-tab',
    title: 'Состояние',
    iconclass: 'ui-icon-tab-state',
    should_appear: (device, _, r_device) => !!device?.has_access(DevicePermission.view_state) &&
        !!(device?.device_type()?.code?.startsWith('L1000') ||
            LegacyDevice.is_legacy_firmware(r_device.capabilities, r_device.thermostat_enabled, r_device.firmware_version, r_device.device_type)),
    render: StateTabContents,
};
